var _defs, _rect, _circle, _path, _circle2, _circle3, _g, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffbc00;\n        stroke: #e87118;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #113559;\n        font-family: AvenirNextLTPro-Bold, 'Avenir Next LT Pro';\n        font-size: 13px;\n        font-weight: 700;\n        glyph-orientation-vertical: 0deg;\n        text-orientation: upright;\n        writing-mode: tb;\n      }\n\n      .cls-4, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-width: .75px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.65,
    y: 2.06,
    width: 45,
    height: 45,
    rx: 5.83,
    ry: 5.83
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.96,
    cy: 19.99,
    r: 13.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.42,14.61c-.16-.08-.54-.26-1.14-.34-.5-.06-.91-.02-1.14,0-.66.07-1.12.23-1.37.34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.22,
    cy: 17.48,
    r: 1.67
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6,
    cy: 17.48,
    r: 1.67
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.34,26.02c.58.05,1.97.16,4.18.21,1.83.04,3.31.02,4.18,0,2.41-.04,4.1-.15,5.01-.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30.57,25.91c-.58-.05-1.97-.16-4.18-.21-1.83-.04-3.31-.02-4.18,0-2.41.04-4.1.15-5.01.21"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.05,14.61c-.16-.08-.54-.26-1.14-.34-.5-.06-.91-.02-1.14,0-.66.07-1.12.23-1.37.34"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(36.27 22.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNs);
export default __webpack_public_path__ + "static/media/NS.9445878179719e05b20e92f724dd398b.svg";
export { ForwardRef as ReactComponent };